/*------------------------------------------------
// File Name:TGY_BASE_HOSPBASICINFO.js
// File Description:TGY_BASE_HOSPBASICINFO store方法
// Author:zxl
// Create Time:2022/12/06 16:37:58
//------------------------------------------------*/

import {
    GetTGY_BASE_HOSPBASICINFOList,
    GetTGY_BASE_HOSPBASICINFOListByPage,
    GetTGY_BASE_HOSPBASICINFOEntity,
    CreateTGY_BASE_HOSPBASICINFOEntity,
    UpdateTGY_BASE_HOSPBASICINFOEntity,
    DeleteTGY_BASE_HOSPBASICINFOEntity,
} from '@/api/gy/base/baseHospbasicinfo'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const TgyBaseHospbasicinfo = {
    namespaced: true,
    state: {
        TgyBaseHospbasicinfoList: [],
        TgyBaseHospbasicinfoListLoading: false,
        TgyBaseHospbasicinfoEntity: null,
        TgyBaseHospbasicinfoShowDlg: false,
    },
    mutations: {
        setTgyBaseHospbasicinfoList(state, dataList) {
            state.TgyBaseHospbasicinfoList = [...dataList]
        },
        setTgyBaseHospbasicinfoListLoading(state, visible) {
            state.TgyBaseHospbasicinfoListLoading = visible
        },
        setTgyBaseHospbasicinfoShowDlg(state, visible) {
            state.TgyBaseHospbasicinfoShowDlg = visible
        },
        setTgyBaseHospbasicinfoEntity(state, entity) {
            state.TgyBaseHospbasicinfoEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreateTgyBaseHospbasicinfo({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreateTGY_BASE_HOSPBASICINFOEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseHospbasicinfoEntity', res.Data)
                        commit('setTgyBaseHospbasicinfoShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetTgyBaseHospbasicinfoEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseHospbasicinfoListLoading', true)
                GetTGY_BASE_HOSPBASICINFOEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseHospbasicinfoEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseHospbasicinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetTgyBaseHospbasicinfoList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseHospbasicinfoListLoading', true)
                GetTGY_BASE_HOSPBASICINFOList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseHospbasicinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseHospbasicinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetTgyBaseHospbasicinfoListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setTgyBaseHospbasicinfoListLoading', true)
                GetTGY_BASE_HOSPBASICINFOListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseHospbasicinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setTgyBaseHospbasicinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdateTgyBaseHospbasicinfo({ commit }, parm) {
            return new Promise((resolve) => {
                UpdateTGY_BASE_HOSPBASICINFOEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setTgyBaseHospbasicinfoShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑TGY_BASE_HOSPBASICINFO
        actEditTgyBaseHospbasicinfoData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    TgyBaseHospbasicinfoID : entity.TgyBaseHospbasicinfoID
                }
                GetTGY_BASE_HOSPBASICINFOEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setTgyBaseHospbasicinfoEntity', res.Data)
                        commit('setTgyBaseHospbasicinfoShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑TGY_BASE_HOSPBASICINFO ,传对象过来
        actEditTgyBaseHospbasicinfo({ commit }, entity) {
            return new Promise(() => {
                commit('setTgyBaseHospbasicinfoEntity', entity)
                commit('setTgyBaseHospbasicinfoShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除TGY_BASE_HOSPBASICINFO
        actDeleteTgyBaseHospbasicinfo({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeleteTGY_BASE_HOSPBASICINFOEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setTgyBaseHospbasicinfoShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


